import { useEffect, useState } from "react";
import List from "../../Components/Sliders/List";
import {
  Container,
  ListWrapper,
  SearchWrapperEmpty,
} from "../../Components/ContainerSoftware/ContainerElements";
import ModalAdd from "../../Components/Sliders/Modals/Add";
import ModalOperations from "../../Components/Sliders/Modals/Operations";
import ModalDelete from "../../Components/Sliders/Modals/Delete";
import axiosConfig from "../../ApiCall/axiosConfig";
import { ToastContainer, toast } from "react-toastify";
import { Slide } from "react-toastify";

const Sliders = () => {
  const [detailItem, setDetailItem] = useState([]);

  const [items, setItems] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [showModalOperations, setShowModalOperations] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);

  const [loading, setLoading] = useState(false);

  const handleOpenModal = (modal, detailItem) => {
    if (modal === "addModal") {
      setShowModal(true);
    } else if (modal === "modalOperations") {
      setShowModalOperations(true);
      setDetailItem(detailItem);
    } else if (modal === "modalDelete") {
      setShowModalDelete(true);
    }
  };
  const handleCloseModal = (modal) => {
    if (modal === "addModal") {
      setShowModal(false);
    } else if (modal === "modalOperations") {
      setShowModalOperations(false);
    } else if (modal === "modalDelete") {
      setShowModalDelete(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    async function fetchData() {
      const token = localStorage.getItem("tokenDeliveryCompanyRoysa");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
      };
      try {
        const { data } = await axiosConfig.get("/slider/company/list", config);
        const itemsData = data.data;
        setItems(itemsData);
        setLoading(false);
      } catch (error) {
        console.log("Error fetching Sliders:", error);
      }
    }

    fetchData();
  }, []);

  const handleAddNew = (toastId) => {
    async function fetchData() {
      const token = localStorage.getItem("tokenDeliveryCompanyRoysa");
      const params = new URLSearchParams([
        ["per_page", 100],
        ["page", 1],
      ]);

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
        params,
      };

      try {
        const { data } = await axiosConfig.get("/slider/company/list", config);
        const itemsData = data.data;
        setItems(itemsData);
        setLoading(false);
      } catch (error) {
        console.log("Error fetching Sliders:", error);
      }
      toast.update(toastId, {
        render: "اسلایدر با موفقیت ثبت شد",
        type: "success",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
    }
    fetchData();
  };
  const handleDelete = (toastId) => {
    async function fetchData() {
      const token = localStorage.getItem("tokenDeliveryCompanyRoysa");
      const params = new URLSearchParams([
        ["per_page", 100],
        ["page", 1],
      ]);

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
        params,
      };

      try {
        const { data } = await axiosConfig.get("/slider/company/list", config);
        const itemsData = data.data;
        setItems(itemsData);
        setLoading(false);
      } catch (error) {
        console.log("Error fetching Sliders:", error);
      }
      toast.update(toastId, {
        render: "اسلایدر با موفقیت حذف شد",
        type: "success",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
    }
    fetchData();
  };

  return (
    <>
      <ToastContainer
        transition={Slide}
        className="toast-position"
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <Container>
        <SearchWrapperEmpty />
        <ListWrapper>
          {loading ? (
            <div className="loadingList">
              <div className="spinner"></div>
            </div>
          ) : (
            <List handleOpenModal={handleOpenModal} data={items} />
          )}
        </ListWrapper>
        <ModalAdd
          showAddModal={showModal}
          handleCloseModal={handleCloseModal}
          handleAddNew={handleAddNew}
        ></ModalAdd>
        <ModalOperations
          showModalOperations={showModalOperations}
          detailItem={detailItem}
          handleCloseModal={handleCloseModal}
          handleOpenModal={handleOpenModal}
        ></ModalOperations>
        <ModalDelete
          showModalDelete={showModalDelete}
          detailItem={detailItem}
          handleCloseModal={handleCloseModal}
          handleDelete={handleDelete}
        ></ModalDelete>
      </Container>
    </>
  );
};
export default Sliders;
